import { Outlet } from "react-router-dom";
import { DashboardShell } from "@/components/DashboardShell";

/**
 * DashboardLayout wraps every authenticated role area with the persistent
 * sidebar/shell. Nested routes render through <Outlet />, so navigation between
 * dashboard subpages happens without remounting the whole shell (preserving
 * scroll position, avoiding auth flashes).
 */
export default function DashboardLayout() {
    return (
        <DashboardShell>
            <Outlet />
        </DashboardShell>
    );
}
